// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3t-1";
export var rateTableServiceLevelDropdown = "_3t-3";
export var rateTableTypeDropdown = "_3t-0";
export var rateTableValueModeDropdown = "_3t-2";